function unknownToString(error: unknown): string {
	if (error instanceof Error) {
		return error.message;
	}
	if (typeof error === "string") {
		return error;
	}
	return String(error);
}

/**
 * Returns a short, user-friendly message for form/UI display.
 * Prefers the first GraphQL error message, then Error.message, then string.
 */
function getDisplayErrorMessage(error: unknown): string {
	const o = error as { response?: { errors?: Array<{ message?: string }> } };
	if (
		typeof o === "object" &&
		o !== null &&
		typeof o.response?.errors?.[0]?.message === "string"
	) {
		return o.response.errors[0].message;
	}
	if (error instanceof Error) {
		return error.message;
	}
	if (typeof error === "string") {
		return error;
	}
	return String(error);
}

export { getDisplayErrorMessage, unknownToString };
